import { useLocation } from 'react-router'
import { Grid, Link } from '@mui/material'

import BottomNavigationMenu from '../bottom-navigation'

import useStyles from './index.styles'

const Footer = () => {
  const classes = useStyles
  const location = useLocation()
  const { pathname } = location

  const footerLinksScreens = ['/login']

  const showBottomNav = /^\/dashboard\/[^/]+\/(devices|alerts|contacts|order-history)(?:\/.*)?$/.test(pathname) || /^\/dashboard\/[^/]+$/.test(pathname)

  return showBottomNav ? (
    <BottomNavigationMenu />
  ) : footerLinksScreens.includes(pathname) ? (
    <Grid container={true} sx={classes.loginFooter} size={12}>
      <Link
        href="https://www.munichre.com/hsb/en/general/legal/privacy-statement.html"
        sx={classes.infoLinks}
        rel="noopener noreferrer"
        target="_blank"
        underline="hover"
      >
        Privacy Statement
      </Link>
      <Link
        href="https://www.munichre.com/hsb/en/general/legal/terms-of-use.html"
        sx={classes.infoLinks}
        rel="noopener noreferrer"
        target="_blank"
        underline="hover"
      >
        Terms & Conditions
      </Link>
    </Grid>
  ) : null
}

export default Footer
